import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { a as addressSchema } from './business-address-schema.js';
import { F as FormController } from './form.js';
import { b as Address } from './Business.js';
import { B as BusinessFormStepV2 } from './business-form-types.js';
import { S as StateOptions } from './state-options.js';
import { n as numberOnlyHandler } from './utils4.js';
import { d as defineCustomElement$5 } from './custom-popper2.js';
import { d as defineCustomElement$4 } from './form-control-error-text2.js';
import { d as defineCustomElement$3 } from './form-control-select2.js';
import { d as defineCustomElement$2 } from './form-control-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const LegalAddressFormStepCore = /*@__PURE__*/ proxyCustomElement(class LegalAddressFormStepCore extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.submitted = createEvent(this, "submitted", 7);
        this.stepCompleted = createEvent(this, "form-step-completed", 7);
        this.formLoading = createEvent(this, "formLoading", 7);
        this.errorEvent = createEvent(this, "error-event", 7);
        this.getData = () => {
            this.formLoading.emit(true);
            this.getBusiness({
                onSuccess: (response) => {
                    this.legal_address = new Address(response.data.legal_address || {});
                    this.formController.setInitialValues(Object.assign({}, this.legal_address));
                },
                onError: ({ error, code, severity }) => {
                    this.errorEvent.emit({
                        message: error,
                        errorCode: code,
                        severity: severity
                    });
                },
                final: () => this.formLoading.emit(false)
            });
        };
        this.sendData = (onSuccess) => {
            let submittedData;
            this.formLoading.emit(true);
            this.patchBusiness({
                payload: this.patchPayload,
                onSuccess: (response) => {
                    submittedData = response;
                    onSuccess();
                },
                onError: ({ error, code, severity }) => {
                    submittedData = error;
                    this.errorEvent.emit({
                        message: error,
                        errorCode: code,
                        severity: severity
                    });
                },
                final: () => {
                    this.submitted.emit({ data: { submittedData } });
                    this.stepCompleted.emit({ data: submittedData, formStep: BusinessFormStepV2.legalAddress });
                    this.formLoading.emit(false);
                }
            });
        };
        this.inputHandler = (name, value) => {
            this.formController.setValues(Object.assign(Object.assign({}, this.formController.values.getValue()), { [name]: value }));
        };
        this.formController = undefined;
        this.errors = {};
        this.legal_address = {};
        this.getBusiness = undefined;
        this.patchBusiness = undefined;
        this.allowOptionalFields = undefined;
    }
    async validateAndSubmit({ onSuccess }) {
        this.formController.validateAndSubmit(() => this.sendData(onSuccess));
    }
    ;
    get patchPayload() {
        let formValues = new Address(this.formController.values.getValue()).payload;
        return { legal_address: formValues };
    }
    componentWillLoad() {
        this.getBusiness && this.getData();
        this.formController = new FormController(addressSchema(this.allowOptionalFields));
    }
    componentDidLoad() {
        this.formController.errors.subscribe(errors => {
            this.errors = Object.assign({}, errors);
        });
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const legalAddressDefaultValue = this.formController.getInitialValues();
        return (h("form", { key: 'cc749f565087adf5a0806a179ebc4682783763bd' }, h("fieldset", { key: '98fecaf00779da20c4f023dd4081be6f616e59ae' }, h("div", { key: '854d921b4b140738cb2cf2f48b51a207eb58c329', class: "d-flex align-items-center gap-2" }, h("legend", { key: 'ae741c143648c14145eac2066fa40799726682e5', class: "mb-0" }, "Legal Address of your Business"), h("form-control-tooltip", { key: 'd30c4a70183f7afc9a809d399b775c5610ef952c', helpText: "No PO Boxes." })), h("hr", { key: '78f7c51df66d265ff1a9f62b38aedfba014ed7cb', class: "mt-2" }), h("div", { key: 'b32031b925e908dc4a9459f0e082312f72fc64f9', class: "row gy-3" }, h("div", { key: '1564426893f46dc7ace7192ce264a10d879bc5c2', class: "col-12" }, h("form-control-text", { key: '9c70add04a610ce6280f7047ad56d260bb0adcf1', name: "line1", label: "Legal Address", inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.line1, errorText: (_a = this.errors) === null || _a === void 0 ? void 0 : _a.line1 })), h("div", { key: 'bba886684830ab3dd7f3470e13bcf8ce970f357f', class: "col-12" }, h("form-control-text", { key: '43c507918eb72b586c43b4839c40499196c41625', name: "line2", label: "Address Line 2 (optional)", inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.line2, errorText: (_b = this.errors) === null || _b === void 0 ? void 0 : _b.line2 })), h("div", { key: 'e9ff6df356c8c4f1ddef5318936d39c4b92a58e9', class: "col-12" }, h("form-control-text", { key: 'ff17e63977ba52fea319f1dfb2936b0836fa1f5f', name: "city", label: "City", inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.city, errorText: (_c = this.errors) === null || _c === void 0 ? void 0 : _c.city })), h("div", { key: 'd0da7fbd59236105cb1f7725eb4fddc0fe0e028b', class: "col-12" }, h("form-control-select", { key: '666abe057f3a06705b42e8bfb3aae4e15b50f8dc', name: "state", label: "State", options: StateOptions, inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.state, errorText: (_d = this.errors) === null || _d === void 0 ? void 0 : _d.state })), h("div", { key: 'c9c2ea66adc0e15f07a9070ca46f685042b41042', class: "col-12" }, h("form-control-text", { key: '614c03164e755b945610b91f8ec7757980956261', name: "postal_code", label: "Postal Code", inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.postal_code, errorText: (_e = this.errors) === null || _e === void 0 ? void 0 : _e.postal_code, maxLength: 5, keyDownHandler: numberOnlyHandler })), h("div", { key: 'cfab73c10bf56bf001a246f0ad8c56fd8c36fbeb', class: "col-12" }, h("form-control-select", { key: 'd42b86c2d2de13504f2934fa63a3e83f998134ac', name: "country", label: "Country", options: [{ label: "United States", value: "USA" }], inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.country, errorText: (_f = this.errors) === null || _f === void 0 ? void 0 : _f.country,
            // just for now so we skip handling country specificities
            disabled: true }))))));
    }
}, [0, "justifi-legal-address-form-step-core", {
        "getBusiness": [16],
        "patchBusiness": [16],
        "allowOptionalFields": [4, "allow-optional-fields"],
        "formController": [32],
        "errors": [32],
        "legal_address": [32],
        "validateAndSubmit": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-legal-address-form-step-core", "custom-popper", "form-control-error-text", "form-control-select", "form-control-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-legal-address-form-step-core":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, LegalAddressFormStepCore);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { LegalAddressFormStepCore as L, defineCustomElement as d };
